import './table.scss'

import Table from './Table'
import Column from './Column'

Table.Column = Column

export { Column }

export default Table